/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Update an institute's slug
 * @export
 * @interface UpdateInstituteSlug
 */
export interface UpdateInstituteSlug {
    /**
     * Slug of the institute
     * @type {string}
     * @memberof UpdateInstituteSlug
     */
    value: string;
}

/**
 * Check if a given object implements the UpdateInstituteSlug interface.
 */
export function instanceOfUpdateInstituteSlug(value: object): value is UpdateInstituteSlug {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function UpdateInstituteSlugFromJSON(json: any): UpdateInstituteSlug {
    return UpdateInstituteSlugFromJSONTyped(json, false);
}

export function UpdateInstituteSlugFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateInstituteSlug {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function UpdateInstituteSlugToJSON(json: any): UpdateInstituteSlug {
    return UpdateInstituteSlugToJSONTyped(json, false);
}

export function UpdateInstituteSlugToJSONTyped(value?: UpdateInstituteSlug | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
    };
}

